import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgZorroAntdModule} from '../../ng-zorro-antd/ng-zorro-antd.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { MensagemComponent } from './mensagem.component';
import { LancamentoMensagemComponent } from './lancamento-mensagem/lancamento-mensagem.component';

@NgModule({
  declarations: [MensagemComponent, LancamentoMensagemComponent],
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule,
    FormsModule, 
    ReactiveFormsModule,
    NgZorroAntdModule,
  ]
})
export class MensagemModule { }
